import React from 'react'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'
// utils
import isFunction from 'lodash/isFunction'

export const useRefetchTree = () => {
  const { treeQueryRefetch } = React.useContext(PlanEditPageContext)

  React.useEffect(() => {
    if (isFunction(treeQueryRefetch)) {
      treeQueryRefetch()
    }
  }, [])
}
